(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('modelViewerPreviewInfoProvider', modelViewerPreviewInfoProvider);

    modelViewerPreviewInfoProvider.$inject = ['$q', '$http', '$cacheFactory', 'modelViewerService', 'modelFilePreviewService'];

    function modelViewerPreviewInfoProvider($q, $http, $cacheFactory, modelViewerService, modelFilePreviewService) {
        var cache = $cacheFactory('PreviewInfo');

        return {
            getPreviewInfoByModelId: getPreviewInfoByModelId
        };

        function getPreviewInfoByModelId(modelId) {
            var key = modelId;

            var cachedPreviewInfo = cache.get(key);
            if (cachedPreviewInfo) {
                return $q.resolve(cachedPreviewInfo);
            }

            return getModel3DPreviewInfo(modelId)
                .then(function (previewInfo) {
                    if (previewInfo) {
                        return previewInfo;
                    }

                    return modelFilePreviewService.getStripePreviewInfo(modelId);
                })
                .then(function (previewInfo) {
                    cache.put(key, previewInfo);
                    return previewInfo;
                });
        }

        function getModel3DPreviewInfo(modelId) {
            if (!modelViewerService.isWebGlSupported()) {
                return $q.resolve(null);
            }

            return modelFilePreviewService.get3DPreviewInfo(modelId)
                .then(function (previewInfo) {

                    if (modelViewerService.canBeShownBy3DViewer(previewInfo)) {
                        return previewInfo;
                    }

                    return null;
                });
        }
    }
}());